import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "onCloseClick", "totalFilteredItemsCount", "children", "filterTypes"];
import { useCallback, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { parse, stringify } from 'hub-http/helpers/params';
import FullScreenModal from './FullScreenModal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileFilterPanel = _ref => {
  let {
      open,
      onCloseClick,
      totalFilteredItemsCount,
      children,
      filterTypes = []
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = useLocation();
  const history = useHistory();
  const originalSearch = useRef(location.search);
  useEffect(() => {
    if (open) {
      originalSearch.current = location.search;
    }
    // only want to update on open prop change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const handleCloseClick = useCallback(() => {
    history.replace(Object.assign({}, location, {
      search: originalSearch.current
    }));
    onCloseClick();
  }, [history, location, onCloseClick]);
  const clearAllowedFilters = useCallback(() => {
    const params = parse(location.search.slice(1));
    Object.keys(params).forEach(filterType => {
      if (filterTypes.includes(filterType)) {
        delete params[filterType];
      }
    });
    history.replace(`${location.pathname}?${stringify(params)}`);
  }, [filterTypes, history, location.pathname, location.search]);
  const applyDisabled = originalSearch.current === location.search;
  const clearDisabled = !location.search;
  return /*#__PURE__*/_jsx(FullScreenModal, Object.assign({
    headerContent: /*#__PURE__*/_jsxs(TFlex, {
      alignItems: "center",
      justify: "end",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "clear-filters",
        disabled: clearDisabled,
        onClick: clearAllowedFilters,
        paddingBlock: "200",
        paddingInline: "300",
        responsive: false,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mobileFilters.clearAll"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "apply-filters",
        disabled: applyDisabled,
        onClick: onCloseClick,
        responsive: false,
        use: "tertiary-extra-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mobileFilters.apply"
        })
      })]
    }),
    onCloseClick: handleCloseClick,
    open: open,
    subheader: /*#__PURE__*/_jsx(View, {
      backgroundColor: "do-not-use-flat-earth",
      paddingBlock: "300",
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-primary-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mobileFilters.numResults",
          options: {
            numResults: totalFilteredItemsCount
          }
        })
      })
    })
  }, restProps, {
    children: children
  }));
};